var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "8 8 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__outline",
    d: "M16,21c-2.7571,0-5-2.2432-5-5V9.5C11,9.2236,11.2239,9,11.5,9S12,9.2236,12,9.5V16c0,2.2056,1.7944,4,4,4s4-1.7944,4-4V9.5         C20,9.2236,20.2239,9,20.5,9S21,9.2236,21,9.5V16C21,18.7568,18.7571,21,16,21z         M20.5,24h-9c-0.2761,0-0.5-0.2236-0.5-0.5s0.2239-0.5,0.5-0.5h9c0.2761,0,0.5,0.2236,0.5,0.5S20.7761,24,20.5,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ui-icon__filled",
    d: "M16,21.5068c-3.0327,0-5.5-2.4673-5.5-5.5v-6.5c0-0.5522,0.4478-1,1-1s1,0.4478,1,1v6.5c0,1.9297,1.5701,3.5,3.5,3.5         s3.5-1.5703,3.5-3.5v-6.5c0-0.5522,0.4478-1,1-1s1,0.4478,1,1v6.5C21.5,19.0396,19.0327,21.5068,16,21.5068z         M20.5,23.9932h-9c-0.2761,0-0.5-0.2236-0.5-0.5s0.2239-0.5,0.5-0.5h9c0.2761,0,0.5,0.2236,0.5,0.5         S20.7761,23.9932,20.5,23.9932z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.1e412a47.svg";
export { ForwardRef as ReactComponent };